import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P21-E1',
    audio: 'img/FriendsPlus/Page20/Audio/audio-e3-p20.mp3',
    video: 'Videos/e3.p20.mp4',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page21/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page20/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page20/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page20/E3/6.jpg', audioUrl: 'img/FriendsPlus/Page20/Audio/hinh1-e3-p20.mp3' },
        { url: 'img/FriendsPlus/Page20/E3/7.jpg' },
        { url: 'img/FriendsPlus/Page20/E3/8.jpg', audioUrl: 'img/FriendsPlus/Page20/Audio/hinh2-e3-p20.mp3' },
        { url: 'img/FriendsPlus/Page20/E3/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page20/E3/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page20/E3/11.jpg' },
        { url: 'img/FriendsPlus/Page20/E3/12.jpg', audioUrl: 'img/FriendsPlus/Page20/Audio/hinh3-e3-p20.mp3' },
        { url: 'img/FriendsPlus/Page20/E3/13.jpg' },
        { url: 'img/FriendsPlus/Page20/E3/14.jpg', audioUrl: 'img/FriendsPlus/Page20/Audio/hinh4-e3-p20.mp3' },
        { url: 'img/FriendsPlus/Page20/E3/15.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page20/E3/16.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page20/E3/17.jpg' },
        { url: 'img/FriendsPlus/Page20/E3/18.jpg', audioUrl: 'img/FriendsPlus/Page20/Audio/hinh5-e3-p20.mp3' },
        { url: 'img/FriendsPlus/Page20/E3/19.jpg' },
        { url: 'img/FriendsPlus/Page20/E3/20.jpg', audioUrl: 'img/FriendsPlus/Page20/Audio/hinh6-e3-p20.mp3' },
        { url: 'img/FriendsPlus/Page20/E3/21.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page20/E3/22.jpg' },
      ],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P21-E2',
    audio: 'img/FriendsPlus/Page21/Audio/audio-e2-p21.mp3',
    video: '',
    component: UI,
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page21/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page21/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page21/Audio/tieude-e2-p21.mp3' },
        { url: 'img/FriendsPlus/Page21/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page21/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page21/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page21/E2/6.jpg', audioUrl: 'img/FriendsPlus/Page21/Audio/hinh1-e2-p21.mp3' },
        { url: 'img/FriendsPlus/Page21/E2/7.jpg' },
        { url: 'img/FriendsPlus/Page21/E2/8.jpg', audioUrl: 'img/FriendsPlus/Page21/Audio/hinh2-e2-p21.mp3' },
        { url: 'img/FriendsPlus/Page21/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page21/E2/10.jpg', audioUrl: 'img/FriendsPlus/Page21/Audio/hinh3-e2-p21.mp3' },
        { url: 'img/FriendsPlus/Page21/E2/11.jpg' },
        { url: 'img/FriendsPlus/Page21/E2/12.jpg', audioUrl: 'img/FriendsPlus/Page21/Audio/hinh4-e2-p21.mp3' },
        { url: 'img/FriendsPlus/Page21/E2/13.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page21/E2/14.jpg' },
      ],
    ],
  },
  3: {
    unit: "Unit 3",
    id: "SB3-U3-P21-E3",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page21/E3/1.jpg" }]],
  },
  4: {
    // Exercise num
    unit: "Unit 3",
    id: "SB3-U3-P21-E4",
    audio: "",
    video: "",
    component: T6,
    exerciseKey: "img/FriendsPlus/Page21/E4/Key/answerKey.png",
    inputSize: 250,
    checkUppercase: true,
    titleImage: "",
    titleQuestion: [{ color: "#44509f", num: "4", title: 'Look and write.' }],
    questionImage: [],
    questions: [
      {
        title: `
          <div>
            <img src="img/FriendsPlus/Page21/E4/title.jpg" style="width: 100%">
            <div style='display: flex; flex-direction: row;position: relative;'>
              <div style='width: '50%'>
                <div>1&nbsp;&nbsp;Does he have a sandwich?</div>
                <div>2&nbsp;&nbsp;Does he have salad?</div>
                <div>3&nbsp;&nbsp;Does she have a milkshake?</div>
                <div>4&nbsp;&nbsp;Does she have chicken?</div>
                <div>5&nbsp;&nbsp;Does he have noodles?</div>
              </div>
              <div style='width: '50%'>
                <div><u style='color:rgb(82,197,235)'>No, he doesn't.</u></div>
                <div>#</div>
                <div>#</div>
                <div>#</div>
                <div>#</div>
              </div>
            </div>
          </div>
        `,
        answer: ["Yes, he does.", "Yes, she does.", "No, she doesn't.", "No, he doesn't."],
      },
    ],
  },
  5: {
    unit: "Unit 3",
    id: "SB3-U3-P21-E5",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page21/E5/1.jpg" }]],
  },
}

export default json;